if (!customElements.get('upsell-form')) {
  customElements.define('upsell-form', class ProductForm extends HTMLElement {
    constructor() {
      super();

      this.form = this.querySelector('form');
      this.parent = this.closest('.product-selection-wrapper');
      this.form.querySelector('[name=id]').disabled = false;
      this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
      this.cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
      this.submitButton = this.querySelector('[type="submit"]');
      if (document.querySelector('cart-drawer')) this.submitButton.setAttribute('aria-haspopup', 'dialog');


    }

    onSubmitHandler(evt) {
      evt.preventDefault();
      
      var datap = [];
      
      var custom_input = document.querySelector('.font_input');
      if(custom_input){
        if(custom_input.value){
          var items = {};
          var prop = {};
          items.id = document.querySelector('.init_name').value;
          items.quantity = 1;
          prop['Add up to 5 letters (Limit: 5)'] = custom_input.value;
          prop['Product Title'] = $('.font_input').attr('data-product_title') +' - '+ $('.font_input').attr('data-cur_var_title');
          items.properties = prop;
          datap.push(items);
        }
      }
      var items = {};
      items.id = this.form.querySelector('[name=id]').value;
      items.quantity = '1';
      datap.push(items);
      
      if (this.submitButton.getAttribute('aria-disabled') === 'true') return;

      this.handleErrorMessage();

      this.submitButton.setAttribute('aria-disabled', true);
      this.submitButton.classList.add('loading');
      this.querySelector('.loading-overlay__spinner').classList.remove('hidden');

      const config = fetchConfig('javascript');
      config.headers['X-Requested-With'] = 'XMLHttpRequest';
      delete config.headers['Content-Type'];

      const formData = new FormData(this.form);

      if (this.cart) {
        formData.append('sections', this.cart.getSectionsToRender().map((section) => section.id));
        formData.append('sections_url', window.location.pathname);
        this.cart.setActiveElement(document.activeElement);
      }
      config.body = formData;
      
      var data = {
          items: datap
      };
      
      fetch(window.Shopify.routes.root+'cart/add.js', {
        body: JSON.stringify(data),
        headers: {
          'Content-Type': 'application/json'
        },
        method: 'POST'
      })
      .then(response => {
        console.log(response)
        return response.json();
      })
      .then((response) => {
          if (response.status) {
            this.handleErrorMessage(response.description);

            const soldOutMessage = this.submitButton.querySelector('.sold-out-message');
            if (!soldOutMessage) return;
            this.submitButton.setAttribute('aria-disabled', true);
            this.submitButton.querySelector('span').classList.add('hidden');
            soldOutMessage.classList.remove('hidden');
            this.error = true;
            return;
          } else if (!this.cart) {
            window.location = window.routes.cart_url;
            return;
          }

          this.error = false;
          const quickAddModal = this.closest('quick-add-modal');
          if (quickAddModal) {
            document.body.addEventListener('modalClosed', () => {
              setTimeout(() => { this.cart.renderContents(response) });
            }, { once: true });
            quickAddModal.hide(true);
          } else {             
            this.cart.renderContents(response);
          }
        })
        .catch((e) => {
          console.error(e);
        })
        .finally(() => {
          this.submitButton.classList.remove('loading');
          if (this.cart && this.cart.classList.contains('is-empty')) this.cart.classList.remove('is-empty');
          if (!this.error) this.submitButton.removeAttribute('aria-disabled');
          this.querySelector('.loading-overlay__spinner').classList.add('hidden');
                 const upsellDrawer = document.querySelector("upsell-drawer");
                 
      if (upsellDrawer) {
          upsellDrawer.classList.remove("active", "animate");
          document.body.classList.remove("overflow-hidden");
         
        }

        });
    }

    handleErrorMessage(errorMessage = false) {
      this.errorMessageWrapper = this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');
      if (!this.errorMessageWrapper) return;
      this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');

      this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);

      if (errorMessage) {
        this.errorMessage.textContent = errorMessage;
      }
    }
  });
}


class UpsellDrawer extends HTMLElement {
  constructor() {
    super();
    this.addEventListener('keyup', (evt) => evt.code === 'Escape' && this.close());
    this.querySelector('#UpsellDrawer-Overlay').addEventListener('click', this.close.bind(this));
    this.setHeaderCartIconAccessibility();
  }
  setHeaderCartIconAccessibility() {
    
    const shopTheLookItems = document.querySelectorAll('.shopthelook');

    shopTheLookItems.forEach((cartLink) => {
      if (!cartLink) return;
      cartLink.setAttribute('role', 'button');
      cartLink.setAttribute('aria-haspopup', 'dialog');
      cartLink.setAttribute('tabindex', '0'); // Make div focusable

      const openHandler = (event) => {
        event.preventDefault();
        this.open(cartLink);
      };
      // Click
      cartLink.addEventListener('click', openHandler);

      // Keyboard SPACE
      cartLink.addEventListener('keydown', (event) => {
        if (event.code.toUpperCase() === 'SPACE') {
          event.preventDefault();
          this.open(cartLink);
        }
      });
    });

  }
  open(triggeredBy) {
    if (triggeredBy) this.setActiveElement(triggeredBy);

    // here the animation doesn't seem to always get triggered. A timeout seem to help
    setTimeout(() => {this.classList.add('animate', 'active')});

    this.addEventListener('transitionend', () => {
      const focusElement = this.querySelector('.drawer__inner') || this.querySelector('.drawer__close');
      trapFocus( focusElement);
    }, { once: true });

    document.body.classList.add('overflow-hidden');
  }
  close() {
    this.classList.remove('active');
    removeTrapFocus(this.activeElement);
    document.body.classList.remove('overflow-hidden');
  }
  setActiveElement(element) {
    this.activeElement = element;
  }
}

customElements.define('upsell-drawer', UpsellDrawer);

document.addEventListener("DOMContentLoaded", () => {
  const addAllBtn = document.querySelector(".upsell-add-all");
  if (!addAllBtn) return;

  addAllBtn.addEventListener("click", async () => {
    addAllBtn.classList.add("loading");

    const allForms = [...document.querySelectorAll("upsell-form")];
    const finalItems = [];

    allForms.forEach((upsell) => {
      const form = upsell.querySelector("form");
      const variantId = form?.querySelector("[name=id]")?.value;
      if (!variantId) return;

      // add engrave if exists (match your original logic)
      const customInput = upsell.querySelector(".font_input");

      if (customInput && customInput.value) {
        let item = {};
        let props = {};
        item.id = upsell.querySelector(".init_name").value;
        item.quantity = 1;

        props["Add up to 5 letters (Limit: 5)"] = customInput.value;
        props["Product Title"] =
          customInput.dataset.product_title + " - " + customInput.dataset.cur_var_title;

        item.properties = props;
        finalItems.push(item);
      }
      // add main product variant
      finalItems.push({
        id: variantId,
        quantity: 1
      });
    });

    if (!finalItems.length) {
      addAllBtn.classList.remove("loading");
      return;
    }

    // Add all at once
    fetch("/cart/add.js", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ items: finalItems })
      })
      .then((res) => res.json())
      .then((response) => {
        const cart = document.querySelector("cart-notification") || document.querySelector("cart-drawer");
        const upsellDrawer = document.querySelector("upsell-drawer");
        if (cart) {
          cart.renderContents(response);
        } else {
          window.location = window.routes.cart_url;
        }
        if (upsellDrawer) {
          upsellDrawer.classList.remove("active", "animate");
          document.body.classList.remove("overflow-hidden");
        }
      })
      .catch(console.error)
      .finally(() => {
        addAllBtn.classList.remove("loading");
          const cart = document.querySelector("cart-notification") || document.querySelector("cart-drawer");
          if (cart && cart.classList.contains("is-empty")) {
            cart.classList.remove("is-empty");
          }
      });
  });
});

